'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errcode = require('err-code');

var pipe = require('it-pipe');

var lp = require('it-length-prefixed');

var pTimeout = require('p-timeout');

var MulticodecTopology = require('libp2p-interfaces/src/topology/multicodec-topology');

var rpc = require('./rpc');

var c = require('./constants');

var Message = require('./message');

var utils = require('./utils');
/**
 * Handle network operations for the dht
 */


var Network = /*#__PURE__*/function () {
  /**
   * Create a new network.
   *
   * @param {KadDHT} self
   */
  function Network(self) {
    _classCallCheck(this, Network);

    this.dht = self;
    this.readMessageTimeout = c.READ_MESSAGE_TIMEOUT;
    this._log = utils.logger(this.dht.peerInfo.id, 'net');
    this._rpc = rpc(this.dht);
    this._onPeerConnected = this._onPeerConnected.bind(this);
    this._running = false;
  }
  /**
   * Start the network.
   * @returns {Promise<void>}
   */


  _createClass(Network, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var topology;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this._running) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (this.dht.isStarted) {
                  _context3.next = 4;
                  break;
                }

                throw errcode(new Error('Can not start network'), 'ERR_CANNOT_START_NETWORK');

              case 4:
                this._running = true; // Incoming streams

                this.dht.registrar.handle(c.PROTOCOL_DHT, this._rpc); // register protocol with topology

                topology = new MulticodecTopology({
                  multicodecs: [c.PROTOCOL_DHT],
                  handlers: {
                    onConnect: this._onPeerConnected,
                    onDisconnect: function onDisconnect() {}
                  }
                });
                _context3.next = 9;
                return this.dht.registrar.register(topology);

              case 9:
                this._registrarId = _context3.sent;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * Stop all network activity.
     * @returns {Promise<void>}
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!this.dht.isStarted && !this.isStarted)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                this._running = false; // unregister protocol and handlers

                _context4.next = 5;
                return this.dht.registrar.unregister(this._registrarId);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
    /**
     * Is the network online?
     *
     * @type {bool}
     */

  }, {
    key: "isStarted",
    get: function get() {
      return this._running;
    }
    /**
     * Are all network components there?
     *
     * @type {bool}
     */

  }, {
    key: "isConnected",
    get: function get() {
      // TODO add a way to check if switch has started or not
      return this.dht.isStarted && this.isStarted;
    }
    /**
     * Registrar notifies a connection successfully with dht protocol.
     * @private
     * @param {PeerInfo} peerInfo remote peer info
     * @returns {Promise<void>}
     */

  }, {
    key: "_onPeerConnected",
    value: function () {
      var _onPeerConnected2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peerInfo) {
        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.dht._add(peerInfo);

              case 2:
                this._log('added to the routing table: %s', peerInfo.id.toB58String());

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, this);
      }));

      function _onPeerConnected(_x2) {
        return _onPeerConnected2.apply(this, arguments);
      }

      return _onPeerConnected;
    }()
    /**
     * Send a request and record RTT for latency measurements.
     * @async
     * @param {PeerId} to - The peer that should receive a message
     * @param {Message} msg - The message to send.
     * @returns {Promise<Message>}
     */

  }, {
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(to, msg) {
        var id, conn, _yield$conn$newStream, stream;

        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.isConnected) {
                  _context6.next = 2;
                  break;
                }

                throw errcode(new Error('Network is offline'), 'ERR_NETWORK_OFFLINE');

              case 2:
                id = to.toB58String();

                this._log('sending to: %s', id);

                _context6.next = 6;
                return this.dht.dialer.connectToPeer(to);

              case 6:
                conn = _context6.sent;
                _context6.next = 9;
                return conn.newStream(c.PROTOCOL_DHT);

              case 9:
                _yield$conn$newStream = _context6.sent;
                stream = _yield$conn$newStream.stream;
                return _context6.abrupt("return", this._writeReadMessage(stream, msg.serialize()));

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendRequest(_x3, _x4) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
    /**
     * Sends a message without expecting an answer.
     *
     * @param {PeerId} to
     * @param {Message} msg
     * @returns {Promise<void>}
     */

  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(to, msg) {
        var id, conn, _yield$conn$newStream2, stream;

        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.isConnected) {
                  _context7.next = 2;
                  break;
                }

                throw errcode(new Error('Network is offline'), 'ERR_NETWORK_OFFLINE');

              case 2:
                id = to.toB58String();

                this._log('sending to: %s', id);

                _context7.next = 6;
                return this.dht.dialer.connectToPeer(to);

              case 6:
                conn = _context7.sent;
                _context7.next = 9;
                return conn.newStream(c.PROTOCOL_DHT);

              case 9:
                _yield$conn$newStream2 = _context7.sent;
                stream = _yield$conn$newStream2.stream;
                return _context7.abrupt("return", this._writeMessage(stream, msg.serialize()));

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendMessage(_x5, _x6) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }()
    /**
     * Write a message and read its response.
     * If no response is received after the specified timeout
     * this will error out.
     *
     * @param {DuplexIterable} stream - the stream to use
     * @param {Buffer} msg - the message to send
     * @returns {Promise<Message>}
     * @private
     */

  }, {
    key: "_writeReadMessage",
    value: function () {
      var _writeReadMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(stream, msg) {
        return _regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", pTimeout(writeReadMessage(stream, msg), this.readMessageTimeout));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7, this);
      }));

      function _writeReadMessage(_x7, _x8) {
        return _writeReadMessage2.apply(this, arguments);
      }

      return _writeReadMessage;
    }()
    /**
     * Write a message to the given stream.
     *
     * @param {DuplexIterable} stream - the stream to use
     * @param {Buffer} msg - the message to send
     * @returns {Promise<void>}
     * @private
     */

  }, {
    key: "_writeMessage",
    value: function _writeMessage(stream, msg) {
      return pipe([msg], lp.encode(), stream);
    }
  }]);

  return Network;
}();

function writeReadMessage(stream, msg) {
  var res;
  return _regeneratorRuntime.async(function writeReadMessage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(pipe([msg], lp.encode(), stream, lp.decode(), /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
              var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

              return _regeneratorRuntime.wrap(function _callee$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _iteratorNormalCompletion = true;
                      _didIteratorError = false;
                      _context2.prev = 2;
                      _iterator = _asyncIterator(source);

                    case 4:
                      _context2.next = 6;
                      return _iterator.next();

                    case 6:
                      _step = _context2.sent;
                      _iteratorNormalCompletion = _step.done;
                      _context2.next = 10;
                      return _step.value;

                    case 10:
                      _value = _context2.sent;

                      if (_iteratorNormalCompletion) {
                        _context2.next = 17;
                        break;
                      }

                      chunk = _value;
                      return _context2.abrupt("return", chunk.slice());

                    case 14:
                      _iteratorNormalCompletion = true;
                      _context2.next = 4;
                      break;

                    case 17:
                      _context2.next = 23;
                      break;

                    case 19:
                      _context2.prev = 19;
                      _context2.t0 = _context2["catch"](2);
                      _didIteratorError = true;
                      _iteratorError = _context2.t0;

                    case 23:
                      _context2.prev = 23;
                      _context2.prev = 24;

                      if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                        _context2.next = 28;
                        break;
                      }

                      _context2.next = 28;
                      return _iterator.return();

                    case 28:
                      _context2.prev = 28;

                      if (!_didIteratorError) {
                        _context2.next = 31;
                        break;
                      }

                      throw _iteratorError;

                    case 31:
                      return _context2.finish(28);

                    case 32:
                      return _context2.finish(23);

                    case 33:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee, null, [[2, 19, 23, 33], [24,, 28, 32]]);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()));

        case 2:
          res = _context.sent;

          if (!(res.length === 0)) {
            _context.next = 5;
            break;
          }

          throw errcode(new Error('No message received'), 'ERR_NO_MESSAGE_RECEIVED');

        case 5:
          return _context.abrupt("return", Message.deserialize(res));

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}

module.exports = Network;